import React, { useEffect, useState } from "react";
import RolesAndPermissionsPage from "../../../../entities/DashboardPage/HRModule/RolesAndPermissions";
import AuthService from "../../../../api/AuthService";
// eslint-disable-next-line import/default
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";

const RolesAndPermissions = () => {

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [permission, setPermission] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");

  // Fetch permissions from API only for Employee role
  const fetchPermissions = async () => {
    if ((role === "Employee" || role === "employee") && employeeId) {
      try {
        const permissionResult = await AuthService.getEmployeePermission(employeeId);
        if (permissionResult?.success && permissionResult?.data) {
          const permissions = permissionResult?.data;
          setPermission(permissions);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    } else {
      // For Admin/SuperAdmin, use localStorage
      const permissionObj = localStorage.getItem("permission");
      setPermission(permissionObj ? JSON.parse(permissionObj) : null);
    }
  };

  useEffect(() => {
    fetchPermissions();
    
    // Listen for permission updates
    const handlePermissionUpdate = () => {
      fetchPermissions();
    };
    
    window.addEventListener("permissionUpdated", handlePermissionUpdate);
    return () => {
      window.removeEventListener("permissionUpdated", handlePermissionUpdate);
    };
  }, []);

  useEffect(() => {
    if (permission !== null || role !== "Employee" && role !== "employee") {
      getRolesPermissionsList("",page,"");
    }
  }, [page, permission])
  const getRolesPermissionsList = async (text,page,sort) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getEmployeeList(text,page,sort);
      if (result?.success) {
        let employees = result?.data?.employees || [];
        
        // Filter data based on permissions for Employee role
        if ((role === "Employee" || role === "employee") && employeeId && permission) {
          const hasViewPermission = permission?.permission?.isView === true;
          const hasEditPermission = permission?.permission?.isEdit === true;
          
          // If employee has edit permission, show all employees (like admin)
          if (hasEditPermission) {
            setTotal(result?.data?.totalCount);
          } else if (hasViewPermission) {
            // If only view permission, show only own data
            employees = employees.filter((emp) => emp?._id === employeeId || emp?.userId === employeeId);
            setTotal(employees.length);
          } else {
            // No view permission, show nothing
            employees = [];
            setTotal(0);
          }
        } else {
          setTotal(result?.data?.totalCount);
        }
        
        setData(employees);
        setFilteredData(employees);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSort = (sort) => {
    getRolesPermissionsList("","",sort)
  }

  return (
    <RolesAndPermissionsPage getRolesPermissionsList={getRolesPermissionsList} data={filteredData.length > 0 ? filteredData : data} page={page} total={total} setPage={setPage} handleSearch={getRolesPermissionsList} handleSort={handleSort}/>
  )

}

export default RolesAndPermissions;
